module.exports = __webpack_public_path__ + "img/delta-down.080e9965.svg";